import { disableScroll, enableScroll } from './lib/ScrollBehavior';

const popupInit = (overlay: HTMLElement) => {
  const id = overlay.getAttribute('id');
  let offset = 0;
  const formWrapper = overlay.querySelector('.gform_wrapper');

  if (formWrapper && formWrapper.classList.contains('gform_validation_error')) {
    overlay.classList.add('overlay--active');
  }
  const closePopup = () => {
    overlay.classList.remove('overlay--active');
    enableScroll(offset);
  };

  const buttons = document.querySelectorAll(`[data-popup="${id}"]`);
  [...buttons].forEach((button) => {
    button.addEventListener('click', () => {
      overlay.classList.add('overlay--active');
      offset = disableScroll();
    });
  });

  if (overlay.classList.contains('overlay--active')) {
    offset = disableScroll();
  }

  const close = overlay.querySelector('.overlay__close');

  close.addEventListener('click', () => {
    closePopup();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  });
};

export default popupInit;
